var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"id":"autre","justify":"center"}},[_c('Bar',{attrs:{"chart-options":_vm.options,"chart-data":_vm.barChartConfig,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }